var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 0.666656C21.3734 0.666656 27.3334 6.62665 27.3334 14C27.3334 21.3733 21.3734 27.3333 14.0001 27.3333C6.62675 27.3333 0.666748 21.3733 0.666748 14C0.666748 6.62665 6.62675 0.666656 14.0001 0.666656ZM18.7867 7.33332L14.0001 12.12L9.21341 7.33332L7.33341 9.21332L12.1201 14L7.33341 18.7867L9.21341 20.6667L14.0001 15.88L18.7867 20.6667L20.6667 18.7867L15.8801 14L20.6667 9.21332L18.7867 7.33332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelCancel);
export default __webpack_public_path__ + "static/media/model-cancel.5e8e32422b68f2888aa8d39da098cfac.svg";
export { ForwardRef as ReactComponent };